@if (showVideo) {
    <div class="cerrix-video-player">
        @switch (embedSourceType) {
            <!-- Youtube -->
            @case (videoSourceTypes.Youtube) {
                <iframe
                    [src]="'https://www.youtube-nocookie.com/embed/' + embedKey | safe"
                    frameborder="0"
                    allow="autoplay; fullscreen; picture-in-picture"
                ></iframe>
            }
            <!-- Vimeo -->
            @case (videoSourceTypes.Vimeo) {
                <iframe
                    [src]="'https://player.vimeo.com/video/' + embedKey | safe"
                    frameborder="0"
                    allow="autoplay; fullscreen; picture-in-picture"
                ></iframe>
                <script src="https://player.vimeo.com/api/player.js"></script>
            }
        }
    </div>
}

@if (url && showValidationMessage) {
    <div class="cerrix-video-validation">
        <span
            >Provided url did not match any supported video services
            <i class="fas fa-question-circle" title="Supported video sources: Youtube, Vimeo"></i
        ></span>
    </div>
}
